interface NonObjectArray {
  type: Exclude<string, 'object'>;
}

interface ObjectArray {
  type: 'object';
  fields: FieldDefinition[];
}

type ArrayDef = NonObjectArray | ObjectArray;

export function isObjectArray(array: ArrayDef): array is ObjectArray {
  return array.type === 'object';
}

export interface FieldDefinition {
  name: string;
  display_name: string;
  description: string;
  required: boolean;
  type?: string;
  primitive_type?: string;
  object_schema?: { fields: FieldDefinition[] };
  array?: ArrayDef;
}

export const FIELD_PATH_SEPARATOR = '/';
